import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';

import { intlShape } from '../../../components/prop-types';

const messages = defineMessages({
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  edit: { id: 'actions.edit', defaultMessage: 'Edit' },
});

const SurveyRespondentsHeader = ({
  isEdit, isSaving, toggleEdit, onEdit, onCancel, intl: { formatMessage },
}) => (
  <div className="p-grid border-bottom">
    <div className="p-col">
      <FormattedMessage id="respondent.plural" defaultMessage="Respondents">
        {text => <span className="title text-muted">{text}</span>}
      </FormattedMessage>
    </div>

    {!isEdit && (
      <div className="p-col-2 align-right">
        <Button type="button" icon="fa fa-pencil" className="p-button-secondary" onClick={toggleEdit} />
      </div>
    )}
    {isEdit && (
      <div className="p-col align-right">
        <Button
          type="button"
          icon={isSaving ? 'pi pi-spin pi-spinner' : ''}
          tooltip={formatMessage(messages.edit)}
          tooltipOptions={{ position: 'bottom' }}
          label={formatMessage(messages.save)}
          onClick={onEdit}
          disabled={isSaving}
        />
        {' '}
        <Button
          type="button"
          className="p-button-secondary"
          label={formatMessage(messages.cancel)}
          onClick={onCancel}
        />
      </div>
    )}
  </div>
);

SurveyRespondentsHeader.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(SurveyRespondentsHeader);
